import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import Loader from "@/components/Loader/LoaderView";

import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
const domain = window.location.hostname;

export default {
  components: {
    Sidebar,
    Navbar,
    Loader
  },
  data() {
    return ({
      isSubmitting : false,
        members:[],
        verifiedMember:[],
        rsvp_code:'',
        message: '',
        isVerified: false,
        errors: {},
        cbo_domain: false,
        user_details: {
          user_role: ''
        },
    });
  },
  methods: {
      getToken() {
      return get_token();
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },
    exportToCSV() {
  const table = $('.table').DataTable();
  const filteredData = table.rows({ search: 'applied' }).data();

  if (!filteredData || filteredData.length === 0) {
    alert("No members to export.");
    return;
  }

  const is_cbo = this.cbo_domain;

  let csvHeader = "Name,Last Name,Email,Phone number";
  if (is_cbo) {
    csvHeader += ",Business,First Time Attending,Chapter";
  }
  csvHeader += ",Event,Event Extras\n";

  const csvRows = [];

  const dataArray = Array.from(filteredData); // ✅ Convert to real array

  for (const row of dataArray) {
    if (!Array.isArray(row) || typeof row[3] !== 'string') continue;

    const member = this.members.find(m => m?.user?.email === row[3]);
    if (!member) continue;

    csvRows.push(this.formatCsvRow(member, is_cbo));
  }

  const csvContent = csvHeader + csvRows.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = "members.csv";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
},
    formatCsvRow(member, is_cbo) {
      const row = [
        member.user?.first_name || '',
        member.user?.last_name || '',
        member.user?.email || '',
        member.user?.phone_number || ''
      ];
    
      if (is_cbo) {
        row.push(
          member.business_name || '',
          member.is_first_time ? 'Yes' : 'No',
          member.chapter || ''
        );
      }
    
      row.push(
        member?.event_name || '',
        `"${member.rsvp_items.map(item => item.item?.item_name).join(" | ")}"`
      );
    
      return row.join(',');
    },    

    filterRSVP() {
        this.isSubmitting = true;
        return new Promise((resolve) => {
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_rsvp/`,
          method: 'GET',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          success: (data) => {
            this.members = data.rsvp_data;
            this.isSubmitting = false;
            resolve(); 
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      });
    },
    verifyRsvpCode(){
      this.isSubmitting=true;
      const formData = new FormData();
      if (!this.rsvp_code) {
        this.message = 'RSVP Code is required';
        return;
    } 
      formData.append('provided_rsvp_code', this.rsvp_code);
      $.ajax({
              type: "POST",
              url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/verify_rsvp_code/`,
              data: formData,
              processData: false,
              contentType: false,
              headers: {
                'Authorization': `Token ${this.getToken()}`,
              },
              success: (response) => {
                const status=response.status
                this.isVerified = true;
                this.verifiedMember=response.rsvp_data
                this.message="RSVP code verified!"
                if (status === "success") {
                            Swal.fire({
                              icon: 'success',
                              title: this.message,
                              showConfirmButton: false,
                              timer: 2000,
                            })}
              },
              error: (response) => {
                this.isVerified=false;
                Swal.close();
                const response_data = response.responseJSON;
                this.message=response_data.message
              },
              complete: () => {
                this.isSubmitting = false;
              }
            });
    },

    cancelRSVP(event_id, user_id = null) {
        const token = this.getToken();


        if (!Number.isInteger(event_id)) {
        Swal.fire('Invalid ID', 'The event ID is not valid.', 'error');
        return;
      }

      const payload = {event_id}

      if(this.user_details.user_role === 'admin' && user_id) {
        payload.user_id = user_id
      }

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/cancel_rsvp/`,
        contentType: 'application/json',
        data: JSON.stringify(payload),
        headers: {
          'Authorization': `Token ${token}`
        },
        success: (data) => {
          if (data.status === 'success') {

            Swal.fire({
              icon: 'success',
              title: 'RSVP Cancelled',
              showConfirmButton: false,
              timer: 2000
            }).then(() => {
              this.members = this.members.filter(member => member.id !== user_id);
              Swal.close();
            })
          } else {
            Swal.fire('Error', data.message || 'Cancel failed', 'error');
          }
        },
        error: (xhr) => {
          const response = xhr.responseJSON || {};
          Swal.fire('Error', response.message || 'Something went wrong', 'error');
        }
      });
    },
    resetForm() {
      this.rsvp_code = '';
      this.message = '';
      this.isVerified = false;
      this.verifiedMember = null;
  },
  },
  mounted() {
    this.user_details = get_user_details();
    this.filterRSVP().then(() => {
      this.$nextTick(() => {
        $('.table').DataTable({
          paging: true,
          searching: true, 
          ordering: true,
          info: true,
          lengthChange: true,
          pageLength: 10,
          language: {
            paginate: {
              previous: "Previous",
              next: "Next"
            },
            info: "Showing _START_ to _END_ of _TOTAL_ entries",
            infoEmpty: "No entries available"
          },
           sortColumn: '',
           sortDirection: 'asc'
        });
      });
    });
    if (domain.includes('cbo')) {
      this.cbo_domain = true;
    }
  }
};
